import { Box, CircularProgress, Divider } from "@mui/joy";
import { Plus } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";

import { DataGridSetting } from "../../../../components";
import { Button } from "../../../../shared";
import { useManufacturer } from "../../../../hooks/query";

import { columnDef } from "./column-def";
import { StatusCellRenderer } from "./GridFrameworks";
import Breadcrumb from "./Breadcrumb";

import type { IManufacturer } from "../../../../interfaces";

export default function List() {
    const navigate = useNavigate();
    const { useList } = useManufacturer();
    const { data, isLoading, isError, error } = useList();

    if (isLoading) {
        return (
            <Box flex={1} display="flex" justifyContent="center" alignItems="center">
                <CircularProgress />
            </Box>
        );
    }

    if (isError) {
        return (
            <Box flex={1} p={2}>
                <Box sx={{ color: "danger.plainColor" }}>
                    {error instanceof Error ? error.message : "Failed to load manufacturers"}
                </Box>
            </Box>
        );
    }

    const manufacturers = (data as IManufacturer[]) || [];

    return (
        <Box flex={1} display={"flex"} flexDirection={"column"}>
            <Breadcrumb />
            <Divider />
            <Box flex={1}>
                <DataGridSetting
                    gridData={manufacturers}
                    columnDefs={columnDef.map((col) => {
                        if (col.cellRenderer === "StatusCellRenderer") {
                            return { ...col, cellRenderer: StatusCellRenderer };
                        }
                        return col;
                    })}
                    quickControlStartDecorator={<CreateManufacturerButton />}
                />
            </Box>
        </Box>
    );
}

function CreateManufacturerButton() {
    return (
        <Box display="flex" alignItems={"center"} ml={1.5}>
            <Button
                variant="soft"
                color="primary"
                component={Link}
                to="/admin/manufacture/create"
                startDecorator={<Plus size={18} />}
            >
                Create Manufacturer
            </Button>
            <Divider orientation="vertical" sx={{ mt: 1, mb: 1, ml: 2 }} />
        </Box>
    );
}
